import { jsx as _jsx } from "react/jsx-runtime";
import { FormattedMessage } from 'react-intl';
const translate = (id, values = {}) => {
    return _jsx(FormattedMessage, { id: id, values: values });
};
export default translate;
